export const PAGE_VIEW = 'page_view';
export const CLICK = 'click';
export const INDOOR_DEVICE_ACKNOWLEDGEMENT = 'IndoorDeviceAcknowledgement';
export const START_FREE_TRIAL_ACTION_ID = 'start_free_trial';
export const CANCEL_FREE_TRIAL_ACTION_ID = 'cancel_free_trial';
export const ACCEPT_AUTHORIZATION_ACTION_ID = 'accept_authorization';
export const DENY_AUTHORIZATION_ACTION_ID = 'deny_authorization';
export const NOT_FOUND_PAGE_ID = 'not_found';
export const ONBOARDING_DENIED_ACTION_ID = 'onboarding_denied';
export const ONBOARDING_PRIMARY = 'onboarding_primary';
export const ONBOARDING_SECONDARY = 'onboarding_secondary';
export const ONBOARDING_CLOSE = 'onboarding_close';
export const ONBOARDING_BACK = 'onboarding_back';
export const TAPPING_PAUSE_TOGGLE = 'tapping_pause_toggle';
export const TAPPING_PAUSE_CONFIRMATION = 'tapping_pause_confirmation';
export const TAPPING_UNPAUSE_TOGGLE = 'tapping_unpause_toggle';
export const TAPPING_RESUME_BUTTON = 'tapping_resume_button';
export const ENROLL_DEVICE = 'enroll_device';
export const UNENROLL_DEVICE = 'unenroll_device';